import "./style.scss";

import React from "react";

import { Text } from "../../atoms";
import { CardListing } from "..";
import { FaArrowLeftLong } from "react-icons/fa6";
import useModalOverflowHidden from "pctHooks/useModalOverflowHidden";

const CardGrid = ({
  tableRows = null,
  data = null,
  parentData = null,
  setOpenGrid,
  openGrid,
  className = null,
}) => {
  useModalOverflowHidden(openGrid);

  const closeGrid = (e) => {
    setOpenGrid(false);
  };

  return (
    <div
      className={`pctOrganism pctCardGridBase ${className ? className : ""}`}
    >
      <div className={`cardGridNav`}>
        <button onClick={closeGrid}>
          <FaArrowLeftLong />
          <Text component="h4" text={"Voltar"} className="" />
        </button>
      </div>
      <div className="cardGridBase sectionList">
        {data && CardListing({ data: data, _parentData: parentData })}
        {tableRows && tableRows}
      </div>
    </div>
  );
};

export default CardGrid;
